import React, { useCallback } from "react";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { useSnackbar } from "notistack";

// This acts as the Type for your older files (allowing "error", "success", etc.)
export type ToastVariant = 'success' | 'error' | 'warning' | 'info' | 'default';

// This acts as the Object for your newer files (allowing ToastVariant.ERROR)
export const ToastVariant = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  DEFAULT: 'default'
} as const;

export const useCustomToast = () => {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const showToast = useCallback(
		(
			message: string,
			variant: ToastVariant,
			_isCloseable: boolean
		) => {
		enqueueSnackbar(`${message}`, {
			variant: variant,
			anchorOrigin: { vertical: "top", horizontal: "left" },
			autoHideDuration: 3000,
				action: (snackbarKey) => (
					<IconButton
						aria-label="close"
						color="inherit"
						sx={{ p: 0.5 }}
						onClick={() => closeSnackbar(snackbarKey)}
					>
						<CloseIcon />
					</IconButton>
				),
			});
		},
		[enqueueSnackbar, closeSnackbar]
	);

	return showToast;
};
